import { useContext } from 'react';

import { FeaturesEnum } from '../../constants/enums/FeaturesEnum';
import { FeatureFlagsContext } from '../../contexts/FeatureFlagsContext';
import { isVisualFeatureEnabled } from '../../utils/featureFlags';
import { ROLE_ENUM } from '../../views/Auth/Login/interfaces/IGoogleUser';
import userAuth from '../userAuth';

interface IAlternatePlarWizardGate {
  isAlternatePlarWizardEnabled: boolean;
  // True only for a learner who finished onboarding while the flag is on: locked to the submission screen.
  isSubmissionOnly: boolean;
}

export const useAlternatePlarWizardGate = (): IAlternatePlarWizardGate => {
  const { auth } = userAuth();
  const { features } = useContext(FeatureFlagsContext);

  const isAlternatePlarWizardEnabled = isVisualFeatureEnabled(
    features.qsemVisualFeatures,
    FeaturesEnum.qsemAlternatePlarWizard,
  );
  const isLearner = auth?.userRole === ROLE_ENUM.STUDENT;
  const isSubmissionOnly = isAlternatePlarWizardEnabled && isLearner && !!auth?.onBoardingCompleted;

  return { isAlternatePlarWizardEnabled, isSubmissionOnly };
};

export default useAlternatePlarWizardGate;
